import { observer } from "mobx-react-lite";
import type React from "react";
import { RouterProvider } from "react-router";

import { router } from "./router";

// TODO: Fix errors related to props in emotion styled components (not all)
// OrderInput.tsx:59 Received `false` for a non-boolean attribute `active`. If you want to write it to the DOM, pass a string instead: active="false" or active={value.toString()}. If you used to conditionally omit it with active={condition && value}, pass active={condition ? value : undefined} instead.

export const App: React.FC = observer(() => {
  return <RouterProvider router={router} />;
});
